var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-tabs"},[_c('div',{staticClass:"tabs-list"},_vm._l((_vm.tabs),function(tab){return _c('span',{key:tab.value,staticClass:"tab-item",class:{active: _vm.value === tab.value},on:{"click":function($event){return _vm.onClickTab(tab.value)}}},[_vm._v(" "+_vm._s(tab.label)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }